import request from '@/utils/request'

function unwrap(promise, fallbackMessage) {
  return promise.then(response => {
    const res = response.data
    if (res.code === 0) return res
    throw new Error(res.msg || fallbackMessage)
  })
}

export function listDeductionOperations(type, params) {
  return unwrap(request({
    url: '/deduction.admin.page',
    method: 'get',
    params: { ...params, type }
  }), '获取抵扣金运营数据失败')
}

function settlementAction(action, data = {}) {
  return unwrap(request({
    url: '/deduction.settlement.batch',
    method: 'post',
    data: { ...data, action }
  }), '月结操作失败')
}

export function listDeductionSettlementBatches(params) {
  return settlementAction('PAGE', params)
}

export function listDeductionSettlementLines(params) {
  return settlementAction('LINES', params)
}

export function generateDeductionSettlementBatch(data) {
  return settlementAction('GENERATE', data)
}

export function issueDeductionSettlementBatch(data) {
  return settlementAction('ISSUE', data)
}

export function payDeductionSettlementBatch(data) {
  return settlementAction('PAY', data)
}

export function confirmDeductionSettlementBatch(data) {
  return settlementAction('CONFIRM', data)
}

export function disputeDeductionSettlementBatch(data) {
  return settlementAction('DISPUTE', data)
}
